if(window.location.pathname === '/cyber-exposure') {
  // 2017 Tooltip triggers for lifecycle wheel
  var measureTT = document.getElementsByClassName('lifecycle-tooltip--measure')[0];
  var modelTT = document.getElementsByClassName('lifecycle-tooltip--model')[0];
  var compareTT = document.getElementsByClassName('lifecycle-tooltip--compare')[0];
  var discoverTT = document.getElementsByClassName('lifecycle-tooltip--discover')[0];
  var assessTT = document.getElementsByClassName('lifecycle-tooltip--assess')[0];
  var analyzeTT = document.getElementsByClassName('lifecycle-tooltip--analyze')[0];
  var fixTT = document.getElementsByClassName('lifecycle-tooltip--fix')[0];
  // var itTT = document.getElementsByClassName('lifecycle-tooltip--it')[0];
  // var iotTT = document.getElementsByClassName('lifecycle-tooltip--iot')[0];
  // var otTT = document.getElementsByClassName('lifecycle-tooltip--ot')[0];
  // var cloudTT = document.getElementsByClassName('lifecycle-tooltip--cloud')[0];




  window.onmousemove = function (e) {
      var x = e.clientX,
          y = e.clientY;
      measureTT.style.top = (y + 25) + 'px';
      measureTT.style.left = (x + -144) + 'px';
      modelTT.style.top = (y + 25) + 'px';
      modelTT.style.left = (x + -144) + 'px';
      compareTT.style.top = (y + 25) + 'px';
      compareTT.style.left = (x + -144) + 'px';
      discoverTT.style.top = (y + 25) + 'px';
      discoverTT.style.left = (x + -144) + 'px';
      assessTT.style.top = (y + 25) + 'px';
      assessTT.style.left = (x + -144) + 'px';
      analyzeTT.style.top = (y + 25) + 'px';
      analyzeTT.style.left = (x + -144) + 'px';
      fixTT.style.top = (y + 25) + 'px';
      fixTT.style.left = (x + -144) + 'px';
      // itTT.style.top = (y + 25) + 'px';
      // itTT.style.left = (x + -144) + 'px';
      // iotTT.style.top = (y + 25) + 'px';
      // iotTT.style.left = (x + -144) + 'px';
      // otTT.style.top = (y + 25) + 'px';
      // otTT.style.left = (x + -144) + 'px';
      // cloudTT.style.top = (y + 25) + 'px';
      // cloudTT.style.left = (x + -144) + 'px';

  };



  (function($){
      "use strict";

      $('#svg__measure').hover(function() {
          $('.lifecycle-tooltip--measure').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__model').hover(function() {
          $('.lifecycle-tooltip--model').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__compare').hover(function() {
          $('.lifecycle-tooltip--compare').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__discover-bg').hover(function() {
          $('.lifecycle-tooltip--discover').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__assess-bg').hover(function() {
          $('.lifecycle-tooltip--assess').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__analyze-bg').hover(function() {
          $('.lifecycle-tooltip--analyze').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__fix-bg').hover(function() {
          $('.lifecycle-tooltip--fix').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      // $('#svg__it-bg').hover(function() {
      //     $('.lifecycle-tooltip--it').addClass('js-show');
      // }, function() {
      //     $('.lifecycle-tooltip').removeClass('js-show');
      // });
      //
      // $('#svg__iot-bg').hover(function() {
      //     $('.lifecycle-tooltip--iot').addClass('js-show');
      // }, function() {
      //     $('.lifecycle-tooltip').removeClass('js-show');
      // });
      //
      // $('#svg__cloud-bg').hover(function() {
      //     $('.lifecycle-tooltip--cloud').addClass('js-show');
      // }, function() {
      //     $('.lifecycle-tooltip').removeClass('js-show');
      // });
      //
      // $('#svg__ot-bg').hover(function() {
      //     $('.lifecycle-tooltip--ot').addClass('js-show');
      // }, function() {
      //     $('.lifecycle-tooltip').removeClass('js-show');
      // });

  })(jQuery);
}

if(jQuery('#TechnologyPartners').length > 0) {
  // 2017 Tooltip triggers for lifecycle wheel
  var measureTT = document.getElementsByClassName('lifecycle-tooltip--measure')[0];
  var modelTT = document.getElementsByClassName('lifecycle-tooltip--model')[0];
  var compareTT = document.getElementsByClassName('lifecycle-tooltip--compare')[0];
  var discoverTT = document.getElementsByClassName('lifecycle-tooltip--discover')[0];
  var assessTT = document.getElementsByClassName('lifecycle-tooltip--assess')[0];
  var analyzeTT = document.getElementsByClassName('lifecycle-tooltip--analyze')[0];
  var fixTT = document.getElementsByClassName('lifecycle-tooltip--fix')[0];
  // var itTT = document.getElementsByClassName('lifecycle-tooltip--it')[0];
  // var iotTT = document.getElementsByClassName('lifecycle-tooltip--iot')[0];
  // var otTT = document.getElementsByClassName('lifecycle-tooltip--ot')[0];
  // var cloudTT = document.getElementsByClassName('lifecycle-tooltip--cloud')[0];




  window.onmousemove = function (e) {
      var x = e.clientX,
          y = e.clientY;
      measureTT.style.top = (y + 25) + 'px';
      measureTT.style.left = (x + -144) + 'px';
      modelTT.style.top = (y + 25) + 'px';
      modelTT.style.left = (x + -144) + 'px';
      compareTT.style.top = (y + 25) + 'px';
      compareTT.style.left = (x + -144) + 'px';
      discoverTT.style.top = (y + 25) + 'px';
      discoverTT.style.left = (x + -144) + 'px';
      assessTT.style.top = (y + 25) + 'px';
      assessTT.style.left = (x + -144) + 'px';
      analyzeTT.style.top = (y + 25) + 'px';
      analyzeTT.style.left = (x + -144) + 'px';
      fixTT.style.top = (y + 25) + 'px';
      fixTT.style.left = (x + -144) + 'px';
      // itTT.style.top = (y + 25) + 'px';
      // itTT.style.left = (x + -144) + 'px';
      // iotTT.style.top = (y + 25) + 'px';
      // iotTT.style.left = (x + -144) + 'px';
      // otTT.style.top = (y + 25) + 'px';
      // otTT.style.left = (x + -144) + 'px';
      // cloudTT.style.top = (y + 25) + 'px';
      // cloudTT.style.left = (x + -144) + 'px';

  };



  (function($){
      "use strict";

      $('#svg__measure').hover(function() {
          $('.lifecycle-tooltip--measure').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__model').hover(function() {
          $('.lifecycle-tooltip--model').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__compare').hover(function() {
          $('.lifecycle-tooltip--compare').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__discover-bg').hover(function() {
          $('.lifecycle-tooltip--discover').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__assess-bg').hover(function() {
          $('.lifecycle-tooltip--assess').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__analyze-bg').hover(function() {
          $('.lifecycle-tooltip--analyze').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      $('#svg__fix-bg').hover(function() {
          $('.lifecycle-tooltip--fix').addClass('js-show');
      }, function() {
          $('.lifecycle-tooltip').removeClass('js-show');
      });

      // $('#svg__it-bg').hover(function() {
      //     $('.lifecycle-tooltip--it').addClass('js-show');
      // }, function() {
      //     $('.lifecycle-tooltip').removeClass('js-show');
      // });
      //
      // $('#svg__iot-bg').hover(function() {
      //     $('.lifecycle-tooltip--iot').addClass('js-show');
      // }, function() {
      //     $('.lifecycle-tooltip').removeClass('js-show');
      // });
      //
      // $('#svg__cloud-bg').hover(function() {
      //     $('.lifecycle-tooltip--cloud').addClass('js-show');
      // }, function() {
      //     $('.lifecycle-tooltip').removeClass('js-show');
      // });
      //
      // $('#svg__ot-bg').hover(function() {
      //     $('.lifecycle-tooltip--ot').addClass('js-show');
      // }, function() {
      //     $('.lifecycle-tooltip').removeClass('js-show');
      // });

  })(jQuery);
}
